import RouteTemplate from 'ember-route-template'
import SkillsMasteredCohortStudentsResults from 'teacher-ui-client/components/page/reporting/maths/skills-mastered/cohort/students-results'

export default RouteTemplate(SkillsMasteredCohortStudentsResults)
